import { z } from "zod";
import { Arrangement, allDrivers, hasArrangements } from "./arrangement.js";
import { AreaBand, ChauffeurDrivers, CookDrivers, DriverName, MaidDrivers, PainterDrivers, } from "./estimate-drivers.js";
import { isTrade } from "./trade.js";
/**
 * A job record's quantities (ADR 0041 §4): the price drivers a record needs so GigSync can learn its own per-unit rates
 * (price per sq ft, per meal, per hour), as counts and fixed choices, never words. The floor area is kept as a band,
 * not the figure the household gave. Drivers the record's scope already holds (meals, who buys the paint, how often a
 * maid comes, the problem) are not repeated here.
 */
export const JobQuantities = z.strictObject({
    area_band: AreaBand.optional(),
    rooms: PainterDrivers.shape.rooms,
    surface: PainterDrivers.shape.surface,
    floors: PainterDrivers.shape.floors,
    house_type: PainterDrivers.shape.house_type,
    finish: PainterDrivers.shape.finish,
    people: CookDrivers.shape.people,
    days_week: CookDrivers.shape.days_week,
    tasks: MaidDrivers.shape.tasks,
    hours: ChauffeurDrivers.shape.hours,
    vehicle: ChauffeurDrivers.shape.vehicle,
    points: z.number().int().min(1).max(30).optional(),
    /** ADR 0046: how long the job was for; absent on a record from before arrangements, which was monthly. */
    arrangement: Arrangement.optional(),
});
/** The driver a quantity stands for: the area band for the area, the rest by their own name. */
const AREA_BAND = JobQuantities.keyof().enum.area_band;
const ARRANGEMENT = JobQuantities.keyof().enum.arrangement;
const driverOf = (key) => (key === AREA_BAND ? DriverName.enum.area_sqft : key);
/** A quantity fits the trade: one of its drivers in any arrangement, or the arrangement of a trade that has them. */
const fits = (trade, key) => key === ARRANGEMENT ? hasArrangements(trade) : allDrivers(trade).includes(driverOf(key));
/** Every quantity is one of the trade's drivers: a cook's record carries no floors, and other work none (ADR 0047). */
export const quantitiesFit = (trade, q) => q === undefined ||
    Object.entries(q).every(([key, value]) => value === undefined || (isTrade(trade) && fits(trade, key)));
//# sourceMappingURL=job-quantities.js.map